/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetProfilePhotoInternalRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_profile_photo_internal.pb'
import {SetProfilePhotoInternalResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/set_profile_photo_internal.pb'


export const setProfilePhotoInternal = (request: SetProfilePhotoInternalRequest, options?: CashRequestOptions) => post<SetProfilePhotoInternalRequest, SetProfilePhotoInternalResponse>("/2.0/cash/set-profile-photo-internal", request, {...options, rejectOnError: true })